module.exports = __webpack_public_path__ + "static/img/5.7e2c58d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/5.png
// module id = n3la
// module chunks = 0